/*** 
 * Odblokowanie dźwięków 
 * 
 * Obejście dla blokady dźwieków przez chrome
 * odtwarza i pauzuje wszystkie <audio>, żeby uzyskać zgodę przeglądarki.
 */

export function initSoundUnlock() {
  let soundsUnlocked = false;

  function unlockSounds() {
    if (!soundsUnlocked) {
      document.querySelectorAll('audio').forEach(audio => {
        try {
          audio.play().catch(() => {}); // próbujemy, żeby przeglądarka "zezwoliła"
          audio.pause();
          audio.currentTime = 0;
        } catch (e) {
          console.warn('Błąd przy odblokowywaniu dźwięku:', e);
        }
      });
      soundsUnlocked = true;
    }
  }

  window.addEventListener('click', unlockSounds);
  window.addEventListener('touchstart', unlockSounds); // dla ekranów dotykowych
}